module.exports = __webpack_public_path__ + "img/fire.29665467.svg";